import { useMutation } from "react-query";
import Angie from "~/utils/angie";
import { fetch } from "~/utils/fetch";

export const useSuggestTasks = (projectId) => {
  return useMutation({
    mutationFn: (data) =>
      fetch({
        url: `${Angie.api_url}/projects/${projectId}/tasks/suggest-tasks`,
        method: "POST",
        body: data,
      }),
  });
};
